import { DocumentSection, EntityDocument } from '@api/api/document-entity';
import { Accordion } from '@design/components/accordion/Accordion';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CitationsAccordionWidget.module.scss';
import {
  CitationsDrawer,
  SelectedCitation,
} from './citations-drawer/CitationsDrawer';
import { Citations } from './components/citations/Citations';

export interface CitationsAccordionWidgetProps {
  citations: DocumentSection[];
  trackingMetadata?: TrackingMetadata;
}

export const CitationsAccordionWidget = ({
  citations,
}: CitationsAccordionWidgetProps) => {
  const { t } = useTranslation(['widget']);
  const [selectedCitation, setSelectedCitation] = useState<SelectedCitation>();

  const onClickCitation = (citationId: string, document: EntityDocument) => {
    setSelectedCitation({ id: citationId, document });
  };

  const onClose = () => {
    setSelectedCitation(undefined);
  };

  const items = [
    {
      title: t('widget:citations.label'),
      content: (
        <ErrorBoundaryWrapper>
          <Citations citations={citations} onClick={onClickCitation} />
        </ErrorBoundaryWrapper>
      ),
    },
  ];

  if (!citations.length) {
    return null;
  }

  return (
    <>
      <Accordion className={styles.styledAccordion} items={items} />
      <CitationsDrawer
        citations={citations}
        isOpen={!!selectedCitation}
        onClose={onClose}
        onSelectCitation={setSelectedCitation}
        selectedCitation={selectedCitation}
      />
    </>
  );
};
